<app-topnav [llttfPage]="true" [pageName]="pageName"></app-topnav>

<div class="h-30"></div>
<div class="container">
    <div class="content" role="main">
        <div class="facility-heading">Edit Organization</div>
        <div class="designatedFacilityForm">

            <app-org-form [isSubmitted]="isSubmitted" [org]="org"></app-org-form>
            <div class="h-30"></div>
            <div class="form-buttons">
                <input type="submit" class="submit-form-button" (click)="onSubmit()" value="Submit" />
                <a routerLink="/org-list" class="submit-form-button cancel-button">Cancel</a>
            </div>
        </div>
    </div>
</div>
<app-footer [bbapp]="true"></app-footer>
